import { findRecurrentPaymentDetail } from "../../infrastructure/repository/recurrent-payments-repository";
import RecurrentPayment from "../../app/domain/RecurrentPayment";
import { adaptRecurrentPaymentDetail } from "../../infrastructure/adapters/adaptRecurrentPayments";
import { translate as t } from "../../infrastructure/translate/localization";
import { showErrorMessage } from "../commons/show-error-message";

export default async function fetchRecurrentPaymentDetail({
  companyId,
  recurrentPaymentId,
  callback,
}: {
  companyId: string;
  recurrentPaymentId: string;
  callback(e: any): void;
}): Promise<void> {
  try {
    const { data } = await findRecurrentPaymentDetail({
      companyId,
      recurrentPaymentId,
    });
    callback(new RecurrentPayment(adaptRecurrentPaymentDetail(data)));
  } catch (error) {
    showErrorMessage(t("common-messages.basic-error-message"));
  }
}
